import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { graphql } from 'react-apollo';
import GET_TOKEN_MUTATION from '../../../graphql/GetToken';
import Button from '../../../components/Button/index';
import { ADMIN_ROLE, ARTIST_ROLE, THEATER_ADMIN_ROLE } from '../../../constants';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      error: '',
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const { mutate, history } = this.props;

    mutate({
      variables: {
        email: this.state.email,
        password: this.state.password,
      },
    })
      .then((res) => {
        const { token, user, enabledStats } = res.data.getSessionToken;
        const role = user.type;

        localStorage.setItem('escenaToken', token);
        localStorage.setItem('escenaRole', role);
        localStorage.setItem('escenaStats', enabledStats);
        if (user.theater) {
          localStorage.setItem('escenaTheater', user.theater.id);
          localStorage.setItem('escenaPlan', user.theater.plan);
        }

        switch (role) {
          case ADMIN_ROLE:
            history.push('/admin/theaters');
            break;
          case THEATER_ADMIN_ROLE:
            history.push('/admin/productions');
            break;
          case ARTIST_ROLE:
            history.push('/me/edit');
            break;
          default:
            history.push('/');
            break;
        }
      })
      .catch(() => {
        this.setState({ error: 'Usuario y/o contraseña incorrectos.' });
      });
  };

  render() {
    const { error } = this.state;
    return (
      <div className="login__page">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="form-content-box">
                <div className="details">
                  <Link to="/">
                    <img
                      src="/img/logos/logo-2.png"
                      className="cm-logo"
                      alt="black-logo"
                    />
                  </Link>
                  <h3>Iniciar Sesión</h3>
                  <form onSubmit={this.handleSubmit}>
                    { error && <p className="red">{ error }</p> }
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        className="input-text"
                        placeholder="Correo electrónico"
                        onChange={e => this.setState({ email: e.target.value })}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="password"
                        name="Password"
                        className="input-text"
                        placeholder="Contraseña"
                        onChange={e =>
                          this.setState({ password: e.target.value })}
                      />
                    </div>
                    <div className="checkbox">
                      <Link
                        className="link-not-important pull-right"
                        to="forgot-password"
                      >
                        Olvidé mi contraseña
                      </Link>
                      <div className="clearfix" />
                    </div>
                    <div className="form-group">
                      <button
                        type="submit"
                        className="button-md button-theme btn-block"
                      >
                        Inicia sesión
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              <div className="form-content-box" style={{ maxWidth: '100%' }}>
                <div className="details">
                  <h3>Registro</h3>
                  <strong>¡Bienvenido a Escena!</strong>
                  <p>
                    Para comenzar a hojear las ofertas disponibles, debes
                    registrarte.
                  </p>
                  <strong>Welcome to Escena!</strong>
                  <p>
                    To start browsing you need to register.
                  </p>
                  <div className="form-group" style={{ marginTop: 30 }}>
                    <Button
                      type="link"
                      url="/theaterRegister"
                      value="Registrarse"
                      icon="fa-university"
                    />
                  </div>
                </div>
              </div>
              <div className="form-content-box" style={{ maxWidth: '100%' }}>
                <div className="thumbnail recent-properties-box">
                  <div className="caption detail">
                    <header className="clearfix">
                      <div className="pull-left">
                        <h1 className="title">
                          Suscríbete
                        </h1>
                      </div>
                    </header>
                    <h3 className="location">
                      <a href="">
                        ¿Quieres sacar más provecho de Escena Digital?
                      </a>
                    </h3>

                    <a href="/plans" target="_blank" className="book-btn">
                          <span className="book-btn-l">
                            <i className="fa fa-link" />
                          </span>
                      <span className="book-btn-r">Cambiar mi plan</span>
                      <div className="clear" />
                    </a>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LoginPage.defaultProps = {};

const withMutation = graphql(GET_TOKEN_MUTATION);
export default withMutation(LoginPage);



// WEBPACK FOOTER //
// ./src/containers/General/LoginPage/index.js